<template>
    <div class="dashboard">
        <LoadingSpinner v-show="loading" />
        <template v-if="notifications.length > 0">
            <transition-group name="notification-list" tag="div" class="notifications" appear>
                <Notification
                    appear
                    v-for="(notification, idx) in notifications"
                    :key="idx"
                    :notification="notification"
                ></Notification>
            </transition-group>
        </template>
        <div class="nav">
            <div class="nav--item darmode-toggler">
                <DarkmodeToggler />
            </div>

            <div class="nav--item logout" @click.prevent="logout">
                <span>Kirjaudu ulos</span>
            </div>
        </div>
        <div class="content--container">
            <Sidebar />
            <main class="page">
                <router-view></router-view>
            </main>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Sidebar from './Sidebar'
import LoadingSpinner from './Loading'
import Notification from './Notification'
import DarkmodeToggler from './DarkmodeToggler'

export default {
    name: 'Dashboard',
    data: () => {
        return {
            loading: false
        }
    },
    metaInfo: {
        title: 'Index',
        titleTemplate: '%s | Karanteeni'
    },
    components: {
        Sidebar,
        LoadingSpinner,
        Notification,
        DarkmodeToggler
    },
    computed: {
        ...mapState('auth', ['notifications', 'currentUser'])
    },
    methods: {
        ...mapActions('auth', ['attemptLogout', 'addNotification']),
        logout() {
            this.loading = true
            this.attemptLogout()
                .then(() => {
                    this.handleSuccessfulLogout()
                })
                .catch((err) => {
                    this.handleUnsuccessfulLogout(err)
                })
        },
        handleSuccessfulLogout() {
            this.loading = false
            this.transferToLoginScreen()
            this.addNotification({
                title: 'Logged Out',
                text: 'Kirjauduit ulos.',
                type: 'success'
            })
        },
        handleUnsuccessfulLogout(err) {
            this.loading = false
            this.addNotification({
                title: 'Oops! Looks like something is wrong!',
                text: err,
                type: 'fail'
            })
        },
        transferToLoginScreen() {
            this.$router.push(this.$route.query.redirect || '/login')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.notifications {
    pointer-events: none;
}

.dashboard {
    height: 100%;
}

.nav {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    box-shadow: var(--top-bar-shadow);
}

.nav--item {
    text-transform: lowercase;
    color: black;
    font-weight: 300;
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.86rem;
    padding: 0.7em 1em;
    padding-bottom: 0.7em;
}

.nav--item.darmode-toggler {
    padding: 0;
}

.search {
    display: none;
}

.logout {
    cursor: pointer;
    background: var(--accent-1);
    background: var(--accent-gradient);
    margin-right: 0;
    color: white;
    font-weight: 400;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.content--container {
    padding: 16px;
    padding-left: 0;
    max-width: 2600px;
    display: flex;
}

.page {
    flex: 1 1 auto;
    padding: 16px 32px;
}

.page p {
    max-width: 840px;
}

.page > div {
    height: 100%;
}

@media screen and (max-width: 800px) {
    .page {
        padding: 1.5em 1em;
    }
}
</style>
